import React from "react";
import banner from "assets/banner.jpg";

function Banner() {
  return (
    <div className="container">
      <div className="columns banner">
        <a href="http://www.hadilive.com" target="_blank">
        <div className="column">
          <img src={banner}/>
        </div>
        </a>
      </div>
    </div>
  );
}

export default Banner;
